<template>
  <v-container fluid>
    <v-row class="d-flex align-center justify-center" style="height: 100vh">
      <v-col cols="11" lg="3" xl="3">
        <v-card class="pa-10" style="border-color: #00a553" outlined>
          <v-form v-model="valid">
            <div class="d-flex align-center justify-center mb-5">
              <v-img max-height="30" src="https://swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg" contain/>
            </div>
            <h2>Welcome to Admin</h2>
            <br>
            <v-text-field v-model="username" label="Email or username" v-on:keypress.enter="login" outlined/>
            <v-text-field v-model="password" label="Password" type="password" v-on:keypress.enter="login" outlined/>
            <v-btn @click="login">Login</v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Auth from '../repositories/auth';
import {mapMutations} from 'vuex';

export default {
  name: "Login",
  data() {
    return {
      valid: false,
      username: '',
      password: '',
    };
  },
  methods: {
    ...mapMutations(['setToken', 'setCurrentUser']),
    async login() {
      if (this.valid) {
        Auth.login(this.username, this.password).then(async (response) => {
          if (response.status < 250) {
            await this.setToken(`Bearer ${response.data.id_token}`);
            await Auth.getUser().then((response) => {
              this.setCurrentUser(response.data);
            });
            await this.$router.push('/dashboard');
          } else
            alert('Invalid credentials');
        }).catch((error) => {
          if (error.response.status === 401)
            alert('Invalid credentials');
        });
      }
    },
  }
}
</script>

<style scoped>

</style>
